var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrintableResource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 92,
    viewBox: "0 0 120 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.825558,
    y: 0.680354,
    width: 57.8272,
    height: 68.0465,
    rx: 4.68857,
    transform: "matrix(0.996203 -0.0874455 0.104542 0.994584 6.4867 5.92744)",
    fill: "url(#paint0_linear_8032_60310)",
    stroke: "#BCEAFD",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 28.3571,
    height: 5.05673,
    rx: 2.52837,
    transform: "matrix(0.996163 -0.0878399 0.103258 0.994702 14.1611 14.6445)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 47.289,
    height: 5.09715,
    rx: 2.54857,
    transform: "matrix(0.996118 -0.0882861 0.102274 0.994791 15.3271 25.1055)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 47.289,
    height: 5.09715,
    rx: 2.54857,
    transform: "matrix(0.996118 -0.088286 0.102275 0.994791 16.2764 34.7422)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 47.289,
    height: 5.09714,
    rx: 2.54857,
    transform: "matrix(0.996118 -0.088286 0.102275 0.994791 17.2393 44.5391)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 47.289,
    height: 5.09715,
    rx: 2.54857,
    transform: "matrix(0.996118 -0.0882861 0.102274 0.994791 18.1885 54.1758)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 47.289,
    height: 5.09715,
    rx: 2.54857,
    transform: "matrix(0.996118 -0.088286 0.102275 0.994791 19.1533 63.9727)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 27.7227,
    y: 10.3945,
    width: 57.4958,
    height: 68.1235,
    rx: 4.43857,
    fill: "#EAEDF0",
    stroke: "url(#paint1_linear_8032_60310)",
    strokeWidth: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 27.7227,
    y: 10.3945,
    width: 57.4958,
    height: 68.1235,
    rx: 4.43857,
    fill: "#EAEDF0",
    stroke: "url(#paint2_linear_8032_60310)",
    strokeWidth: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 27.4727,
    y: 10.1445,
    width: 57.9958,
    height: 68.6235,
    rx: 4.68857,
    fill: "url(#paint3_linear_8032_60310)",
    stroke: "#BCEAFD",
    strokeWidth: 1.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 33.7812,
    y: 17.2969,
    width: 28.2353,
    height: 4.93827,
    rx: 2.46914,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 33.7812,
    y: 30.1367,
    width: 47.395,
    height: 4.93827,
    rx: 2.46914,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 33.7812,
    y: 39.0234,
    width: 47.395,
    height: 4.93827,
    rx: 2.46914,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 33.7812,
    y: 48.9023,
    width: 47.395,
    height: 4.93827,
    rx: 2.46914,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 33.7812,
    y: 58.7773,
    width: 27.2269,
    height: 4.93827,
    rx: 2.46914,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.4369 19.9355L78.3143 63.7807L78.1041 64.0635L71.6759 69.6412L67.3648 71.5566L66.44 67.3855L66.4449 58.7126L66.5171 58.3549L86.6397 14.5097L86.9883 13.7502L87.7479 14.0988L98.0208 18.8135L98.7994 19.1708L98.4369 19.9355Z",
    fill: "#F5BC23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6165 58.1425L67.9063 55.3322L67.9201 55.327L68.3003 56.3521L68.7164 57.4741L69.8384 57.058L70.8634 56.6778L71.2435 57.7029L71.6596 58.8249L72.7816 58.4088L73.8067 58.0286L74.1868 59.0537L74.6029 60.1757L75.7249 59.7596L76.7499 59.3794L77.1301 60.4045L77.5462 61.5265L78.6682 61.1104L79.6932 60.7302L79.7035 60.7579L78.405 63.5873L78.3178 63.7772L78.1076 64.06L71.6766 69.6369L67.4357 71.0566L66.4405 67.3809L66.4484 58.7091L66.5206 58.3514L66.6165 58.1425Z",
    fill: "#FBE294"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3328 20.3466L87.0598 15.6319L86.3003 15.2833L86.6489 14.5238L88.845 9.73857C89.5422 8.21947 90.7999 7.10702 92.2682 6.5625C93.7365 6.01798 95.4103 6.02754 96.9345 6.73858L97.6371 7.06102C99.1562 7.75821 100.269 9.01589 100.813 10.4842C101.358 11.9525 101.348 13.6263 100.637 15.1505L98.4409 19.9357L98.0923 20.6952L97.3328 20.3466Z",
    fill: "#004786"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3328 20.3461L87.0598 15.6314L86.2864 15.2879L86.6437 14.5094L87.367 12.9333L99.173 18.3401L98.4409 19.9352L98.0923 20.6947L97.3328 20.3461Z",
    fill: "#F4F8FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1317 19.3346L76.7382 59.3872L75.7132 59.7674L74.5912 60.1834L74.1751 59.0614L73.7949 58.0364L72.7699 58.4166L71.6479 58.8326L71.2318 57.7106L70.8619 56.7133L89.2503 16.6469L95.1317 19.3346Z",
    fill: "#FBE294"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.65 58.718L71.6853 56.4693L71.9685 57.2328L72.3057 58.1422L73.2174 57.8041L74.0503 57.4953L74.3584 58.3261L74.6957 59.2355L75.6074 58.8974L76.384 58.6094L75.3415 60.8735L75.2706 61.0275L75.1192 61.2752L68.8503 69.539L68.6389 69.6677L68.0012 70.6329L68.2952 69.285L70.4893 59.1479L70.572 58.8874L70.65 58.718Z",
    fill: "#FEE8AD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8149 69.5327L66.9004 73.2335C66.7707 73.3311 66.5848 73.2417 66.5801 73.0794L66.4082 67.0628L71.8149 69.5327Z",
    fill: "#004786"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8032_60310",
    x1: 136.754,
    y1: 199.335,
    x2: -14.8802,
    y2: -11.3539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48A8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFFAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8032_60310",
    x1: 28.7395,
    y1: 8.40832,
    x2: 89.1971,
    y2: 85.1916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0F1FD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8032_60310",
    x1: 28.7395,
    y1: 8.40832,
    x2: 89.1971,
    y2: 85.1916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0F1FD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8032_60310",
    x1: 163.866,
    y1: 210.384,
    x2: 10.7116,
    y2: -1.26587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48A8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFFAFE"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintableResource);
export default __webpack_public_path__ + "static/media/printable_resource.d0653e2a7137b81ecbc475f380fc3d35.svg";
export { ForwardRef as ReactComponent };